import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const AaaGameInformationPage = loadable(() =>
  withDefaultLoaderModifiers(import("./AaaGameInformationPage"))
);
